<template>
  <p>
    <span class="mr-2">{{ passtext }}</span>
    <v-icon class="mr-1" @click="visible = !visible" v-if="visible">mdi-eye-off-outline</v-icon>
    <v-icon class="mr-1" @click="visible = !visible" v-else>mdi-eye-outline</v-icon>
    <v-icon class="mr-1" @click="copy">mdi-content-copy</v-icon>
    <v-snackbar v-model="clipboardCopied" :timeout="timeout" color="green">
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="clipboardCopied = false">
          Close
        </v-btn>
      </template>
      <h3>Password Copied !! </h3>
    </v-snackbar>
  </p>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('atlasadmin');

export default {
  name: 'PrivilegePasswordElement',
  computed: {
    ...mapState(['password']),
    passtext() {
      return this.visible ? this.password.password : '*'.repeat(this.password.password.length)
    }
  },
  methods: {
    copy(){
      // const tempInput = document.createElement("input");
      // tempInput.style = "position: absolute; left: -1000px; top: -1000px";
      // tempInput.value = this.password.password;
      // document.body.appendChild(tempInput);
      // tempInput.select();
      // document.execCommand("copy");
      // document.body.removeChild(tempInput);
      navigator.clipboard.writeText(this.password.password).then(()=>{
        this.clipboardCopied = true;
      })
    }
  },
  data() {
    return {
      visible: false,
      clipboardCopied: false,
      timeout: 1000
    };
  }
}
</script>

<style>

</style>
